import { Card } from '@unfold/card';
import {
  styled,
  flexColumnAlignCenter,
  flexAlignCenter,
  flexColumn,
  Theme,
  Colors,
} from '@unfold/theme';
import { Button } from '@unfold/button';

export const StyledStory = styled(Card)`
  ${flexColumnAlignCenter}
  background-color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.WHITE : Colors.DG600};
  transition: all 0.2s ease-in-out;
  max-width: 244px;
  cursor: pointer;

  &:hover {
    box-shadow:${({ theme }): string =>
      theme.name === Theme.LIGHT ? '0px 10px 50px #e8e8e8' : 'none'};
    transform: scale(1.02);
  }
`;

export const StoryImageWrapper = styled.div`
  flex: 1 1 auto;
  width: 100%;
  position: relative;
  border-radius: 6px;
`;

export const StoryImageThumbnail = styled.div`
  width: 100%;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background-color: #d8d8d8;
  height: 230px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StoryImage = styled.div<{ url: string }>`
  width: 100%;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  height: 230px;
  background-image: ${({ url }): string => `url(${url})`};
  background-size: cover;
`;

export const StoryFooter = styled.div`
  width: 100%;
  height: 60px;
  ${flexAlignCenter}
  padding: 0 15px;
`;

export const StoryFooterLeft = styled.div`
  flex: 1;
  ${flexColumn}
  min-width: 0;
`;

export const StoryFooterRight = styled.div`
  height: 50px;

  svg {
    circle {
      fill: ${({ theme }): string =>
        theme.name === Theme.LIGHT ? Colors.BLACK : Colors.WHITE};
    }
  }
`;

export const StoryName = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StoryDate = styled.span`
  color: #9c9c9c;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  margin-top: 3px;
`;

export const StyledButton = styled(Button)`
  &:hover {
    background-color: unset;
  }
`;
